<template>
  <div class="lp-page">
    <component
      :is="sectionType"
      v-for="sectionType in sections"
      :ref="getSectionRefName(sectionType)"
      v-bind="safeInput"
      :input="safeInput"
      :page-data="safeInput"
      @lp:section-ready="readySections[sectionType] = true"
      v-on="lpEventBinding"
      :section-data="safeInput[sectionType]"
      input-prefix="Hero1"></component>
  </div>
</template>

<script>
import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory";
// use context to create an import map for all the sections we have.
// section components is a map - SectionName: [asyncComponentLoader] - to be assigned to components, below.
// result: now we do not need to add imports,ever, and it is all async (and has code splitting)
let sectionComponents = {};
require
  .context(
    "@/client/applications/meitavlp/components/lp/sections",
    true,
    /\.*.vue/
  )
  .keys()
  .forEach((key) => {
    let cleanKey = key.replace("./", "").replace(".vue", "");
    sectionComponents[cleanKey] = asyncComponentFactory(
      `components/lp/sections/${cleanKey}.vue`,
      true
    );
  });

export default {
  components: {
    ...sectionComponents,
  },
  props: {
    // landing page data
    title: {
      type: [String, Boolean],
      default: "",
    },
    input: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      exampleDynamicComponent: "hero1",
      readySections: {},
    };
  },
  watch: {
    readySections: {
      handler(newVal) {
        if (this.areSectionsReady) {
          this.handleAllSectionsReady();
        }
      },
      deep: true,
    },
  },
  mounted() {},
  computed: {
    safeInput() {
      // prevent "inheritence" of fields that may match HTML props, such as "title"
      let res = { ...this.input };
      delete res.title;
      delete res.alias;
      delete res.id;
      delete res.class;
      return res;
    },
    sections() {
      if (!this.input || !utilities.isObject(this.input.sectionTypeList)) {
        return [];
      }
      return Object.values(this.input.sectionTypeList).map((item) => item.type);
    },
    sectionRefNames() {
      return this.sections.map((sectionType) =>
        this.getSectionRefName(sectionType)
      );
    },
    sectionRefs() {
      return this.sectionRefNames.map((key) => {
        if (Array.isArray(this.$refs[key]) && this.$refs[key][0]) {
          return this.$refs[key][0];
        }

        return this.$refs[key];
      });
    },
    areSectionsReady() {
      const areArraysEqual = (arr1, arr2) =>
        arr1.length === arr2.length &&
        arr1.sort().every((value, index) => value === arr2.sort()[index]);

      return areArraysEqual(Object.keys(this.readySections), this.sections);
    },
    lpEventBinding() {
      let res = {};
      Object.values(config.lp.elementActions).forEach((eventOption) => {
        if (["none", "_self", "_blank"].includes(eventOption.value)) {
          return true;
        }
        res[eventOption.value] = this.generalSectionEventHandler;
      });

      return res;
    },
  },
  provide() {
    return {
      triggerSectionsEvent: this.triggerSectionsEvent,
    };
  },
  methods: {
    generalSectionEventHandler(e) {
      let eventName = e.event;
      if (eventName.startsWith("sectionEvent")) {
        let parsedEventName = utilities.lcFirst(
          eventName.replace("sectionEvent", "")
        );
        this.triggerSectionsEvent(parsedEventName, e);
      }
    },
    triggerSectionsEvent(event, data) {
      let handlerName = `${event}Handler`;
      this.sectionRefs.forEach((ref) => {
        if (ref && typeof ref[handlerName] === "function") {
          ref[handlerName](data);
        }
      });
    },
    handleAllSectionsReady() {
      this.triggerSectionsEvent("lpReady", {
        component: this,
        sectionsTypes: this.sections,
      });
    },
    getSectionRefName(sectionType) {
      return `section${sectionType}`;
    },
  },
};
</script>
